var percentilesData = { medianDurationSec: 90000, percentileDurationSec: 121200 };
var InCompleteCallsStatsBuilder = /** @class */ (function () {
    function InCompleteCallsStatsBuilder() {
        this.incompleteCallsStats = {
            inIvr: 333,
            inQueue: 4,
            inCall: 20,
        };
    }
    InCompleteCallsStatsBuilder.prototype.withInIvr = function (inIvr) {
        this.incompleteCallsStats.inIvr = inIvr;
        return this;
    };
    InCompleteCallsStatsBuilder.prototype.withInQueue = function (inQueue) {
        this.incompleteCallsStats.inQueue = inQueue;
        return this;
    };
    InCompleteCallsStatsBuilder.prototype.withInCall = function (inCall) {
        this.incompleteCallsStats.inCall = inCall;
        return this;
    };
    InCompleteCallsStatsBuilder.prototype.build = function () {
        return this.incompleteCallsStats;
    };
    return InCompleteCallsStatsBuilder;
}());
export { InCompleteCallsStatsBuilder };
var TimeFrameCallStatsDataBuilder = /** @class */ (function () {
    function TimeFrameCallStatsDataBuilder() {
        this.timeFrameCallStatsData = {
            totalCalls: 1244,
            noAnswer: 256,
            voiceMails: 156,
            completed: 158,
            callDuration: percentilesData,
            waitDuration: percentilesData,
        };
    }
    TimeFrameCallStatsDataBuilder.prototype.withTotalCalls = function (totalCalls) {
        this.timeFrameCallStatsData.totalCalls = totalCalls;
        return this;
    };
    TimeFrameCallStatsDataBuilder.prototype.withNoAnswer = function (noAnswer) {
        this.timeFrameCallStatsData.noAnswer = noAnswer;
        return this;
    };
    TimeFrameCallStatsDataBuilder.prototype.withVoiceMails = function (voiceMails) {
        this.timeFrameCallStatsData.voiceMails = voiceMails;
        return this;
    };
    TimeFrameCallStatsDataBuilder.prototype.withCompleted = function (completed) {
        this.timeFrameCallStatsData.completed = completed;
        return this;
    };
    TimeFrameCallStatsDataBuilder.prototype.build = function () {
        return this.timeFrameCallStatsData;
    };
    return TimeFrameCallStatsDataBuilder;
}());
export { TimeFrameCallStatsDataBuilder };
var TimeFrameCallStatsBuilder = /** @class */ (function () {
    function TimeFrameCallStatsBuilder() {
        this.timeFrameCallStats = {
            callbackStats: new TimeFrameCallStatsDataBuilder().build(),
            inboundStats: new TimeFrameCallStatsDataBuilder().build(),
            outboundStats: new TimeFrameCallStatsDataBuilder().build(),
            globalStats: new TimeFrameCallStatsDataBuilder().build(),
            inCompleteStats: new InCompleteCallsStatsBuilder().build(),
        };
    }
    TimeFrameCallStatsBuilder.prototype.withCallbackStats = function (callbackStats) {
        this.timeFrameCallStats.callbackStats = callbackStats;
        return this;
    };
    TimeFrameCallStatsBuilder.prototype.withInboundStats = function (inboundStats) {
        this.timeFrameCallStats.inboundStats = inboundStats;
        return this;
    };
    TimeFrameCallStatsBuilder.prototype.withOutboundStats = function (outboundStats) {
        this.timeFrameCallStats.outboundStats = outboundStats;
        return this;
    };
    TimeFrameCallStatsBuilder.prototype.withGlobalStats = function (globalStats) {
        this.timeFrameCallStats.globalStats = globalStats;
        return this;
    };
    TimeFrameCallStatsBuilder.prototype.withInCompleteStats = function (inCompleteStats) {
        this.timeFrameCallStats.inCompleteStats = inCompleteStats;
        return this;
    };
    TimeFrameCallStatsBuilder.prototype.build = function () {
        return this.timeFrameCallStats;
    };
    return TimeFrameCallStatsBuilder;
}());
export { TimeFrameCallStatsBuilder };
//# sourceMappingURL=time-frame-call-stats.builder.js.map